import ShowroomExtraContent from "./showroom-extra-content";

export default ShowroomExtraContent;